import { useEffect, useState } from 'react';
import azureDevOpsService from './azureDevOpsService';

// Les environnements dont le service de logs sait retrouver un TraceId
// (cf. LOGS_ZONES dans server.js).
export const ZONES_TRACE = ['qa1', 'qa2', 'qa3', 'qa4', 'val05', 'val9', 'dev01'];

// De l'environnement d'un build a la zone de logs ou chercher ses TraceId.
//
// Les pages d'equipe cherchaient dans une zone FIXE (qa1 ou qa3 selon la
// page). Or une meme suite tourne sur plusieurs environnements : au
// 15/09/2026, 46 builds de test sur 118 visaient val05 ou val9. Un TraceId de
// val05 etait donc cherche dans les logs de qa3 - sans erreur, juste une
// reponse vide ou celle d'un autre environnement.
//
// Les valeurs ne sont pas normalisees : 'qa3', 'QA1-Unified', 'unified qa1'
// (cf. argonos-log-intelligence/src/campagnes/campagnes.js). Hors qa, on
// n'accepte que le nom exact.
//
// Un environnement sans service de logs (perf1...) est rendu tel quel : le
// serveur le refuse avec un message explicite, plutot que de le replier sur
// une autre zone.
export function zoneDeLEnv(env) {
  const brut = String(env || '').trim().toLowerCase();
  if (!brut) return null;
  const qa = /qa([1-4])/.exec(brut);
  if (qa) return `qa${qa[1]}`;
  return brut;
}

// La zone d'un build, lue depuis ses parametres. `zoneParDefaut` ne sert que
// tant que le build n'a pas repondu, ou s'il ne porte aucun environnement :
// c'est le comportement d'avant, garde pour les pipelines sans parametre.
export function useZoneDeTrace(buildId, zoneParDefaut) {
  const [zone, setZone] = useState(zoneParDefaut);

  useEffect(() => {
    let annule = false;
    setZone(zoneParDefaut);
    if (!buildId) return undefined;
    azureDevOpsService.getEnvironmentFromBuild(buildId)
      .then((env) => {
        if (!annule) setZone(zoneDeLEnv(env) || zoneParDefaut);
      })
      .catch(() => {});
    return () => { annule = true; };
  }, [buildId, zoneParDefaut]);

  return zone;
}
